import Modal from '../../../../../../../components/Modal'
import './style.scss'

interface NoDataProp {
    visible: boolean
    onClickClose: () => void
    onClickCancel: () => void
    onClickSave: () => void
}
function ConfirmationModal(props: NoDataProp) {
    return (
        <Modal
            className="activity-modal-confirmation-modal"
            visible={props.visible}
            title="Save changes?"
            primaryButtonText="Save and close"
            secondaryButtonText="Exit without saving"
            tertiaryButtonText="Cancel"
            onClickSecondary={props.onClickClose}
            onClickTertiary={props.onClickCancel}
            onClickPrimary={props.onClickSave}
        >
            <span>Any unsaved changes will be lost. Do you want to save changes before closing this activity?</span>
        </Modal>
    )
}

export default ConfirmationModal
